<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="headline primary white--text">
                    {{ 'Equipment relationships'|translate }}
                </v-card-title>
                <v-card-actions >
                    <v-spacer></v-spacer>

                    <span style="width:300px;" v-if="!graphMode"><v-text-field class="mr-4" clearable v-model="search" type="text"
                                                             :label="'Keyword filter'|translate"></v-text-field></span>
                    <span style="width:300px;" v-if="graphMode"><v-select class="mr-4" :items="availableTypes" v-model="selectedType" type="text"
                                                             :label="'Relationship type'|translate"></v-select></span>
                    <v-btn class="accent" @click="graphMode=false" v-if="graphMode"
                    >
                        <v-icon small class="mr-2">fa-list</v-icon>
                        {{ 'List view'|translate }}
                    </v-btn>
                    <v-btn class="accent" @click="graphMode=true" v-if="!graphMode"
                    >
                        <v-icon small class="mr-2">fa-sitemap</v-icon>
                        {{ 'Graph view'|translate }}
                    </v-btn>
                    <v-btn class="accent" @click="editedItem=null;dialog=true"
                           :disabled="!$can('update', 'Equipment')">
                        <v-icon small class="mr-2">fa-plus</v-icon>
                        {{ 'Add Record'|translate }}
                    </v-btn>
                    <v-btn class="accent" @click="uploadDialog = true" :disabled="!$can('update', 'Equipment')">
                        <v-icon small class="mr-2">fa-file-upload</v-icon>
                        {{ 'Upload'|translate }}
                    </v-btn>
                    <v-btn class="accent" @click="exportItems">
                        <v-icon small class="mr-2">fa-download</v-icon>
                        {{ 'Download'|translate }}
                    </v-btn>

                </v-card-actions>
                <v-card-text v-if="!graphMode">
                    <v-data-table
                        :headers="headers"
                        :items="equipmentRelationships"
                        class="elevation-1"
                        :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                        :items-per-page="25"
                        :search="search2"
                    >
                        <template v-slot:items="props">
                            <td>{{ props.item.equipment_relationship_id }}</td>
                            <td>{{ props.item.type }}</td>
                            <td><span v-if="props.item.equip1&&nameMap[props.item.equip1]"></span>{{ nameMap[props.item.equip1]}}</td>
                            <td><span v-if="props.item.equip2&&nameMap[props.item.equip2]"></span>{{ nameMap[props.item.equip2]}}</td>
                            <td>
                                <v-icon
                                    small
                                    class="mr-2"
                                    v-if="$can('update', 'Equipment')"
                                    @click="$can('update', 'Equipment') && editItem(props.item)"
                                >
                                    fa-edit
                                </v-icon>
                                <v-icon
                                    small
                                    v-if="$can('update', 'Equipment')"
                                    @click="$can('update', 'Equipment') && deleteItem(props.item)"
                                >
                                    fa-trash
                                </v-icon>
                            </td>
                        </template>
                        <template v-slot:no-data>
                            <v-btn color="primary" @click="initialize">{{ 'Reset'|translate }}</v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-card-text v-if="graphMode">
                    <vue-echart v-if="ecConfig" :config="ecConfig" :height="height" @click="handleECClick"></vue-echart>
                </v-card-text>
                <equipment-relationship-dialog v-model="dialog" :item="editedItem"
                                               v-on:doreload="refresh()"></equipment-relationship-dialog>
                <maintenance-upload-dialog
                    v-model="uploadDialog"
                    v-if="uploadDialog"
                    endpoint="/equipment-relationships-upload/"
                    v-on:doreload="refresh()"
                    title="Equipment Relationships Upload"
                    upload-title="Upload Equipment Relationships"
                ></maintenance-upload-dialog>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {getEquipmentRelationship, deleteEquipmentRelationship} from '../helper'
import EquipmentRelationshipDialog from "../components/EquipmentRelationshipDialog";
import VueEchart from "@/components/VueEchart";
import MaintenanceUploadDialog from "../components/maintenance/MaintenanceUploadDialog";
import {exportCSV} from '../tocsv'

export default {
    name: 'EquipmentRelationships',
    components: {EquipmentRelationshipDialog,VueEchart,MaintenanceUploadDialog},
    props: {
        height: {type: Number, default: 800},
    },
    data() {
        return {
            dialog: false,
            headers: [
                {text: this.$options.filters.translate('ID'), value: 'equipment_relationship_id'},
                {text: this.$options.filters.translate('Type'), value: 'type'},
                {text: this.$options.filters.translate('Equipment 1'), value: 'equip1'},
                {text: this.$options.filters.translate('Equipment 2'), value: 'equip2'},
                {text: this.$options.filters.translate('Actions'), sortable: false},
            ],
            equipmentRelationships: [],
            editedItem: {},
            nameMap:{},
            search: '',
            search2: '',
            timeout: null,
            graphMode: false,
            uploadDialog:false,
            selectedType:null,
            availableTypes:[]
        }
    },
    computed: {
        ecConfig() {
            if(this.equipmentRelationships.length<1||!this.selectedType){
                return null
            }
            let relationships=this.equipmentRelationships.filter(x=>x.type===this.selectedType)
            let graph={
                categories:[],
                nodes:[],
                links:[]
            }
            let usedIds=[]
            for (let relationship of relationships){
                graph.links.push({
                    source:relationship.equip1.toString(),
                    target:relationship.equip2.toString()
                })
                if (usedIds.indexOf(relationship.equip1)<0){
                    usedIds.push(relationship.equip1)
                }
                if (usedIds.indexOf(relationship.equip2)<0){
                    usedIds.push(relationship.equip2)
                }
            }
            for (let usedId of usedIds){
                let newNode={
                    id:usedId.toString(),
                    name:this.nameMap[usedId]
                }
                let type=this.$store.state.pointsListStore.pointsList.equipment_details[newNode.name].equipment_type
                if (graph.categories.indexOf(type)<0){
                    graph.categories.push(type)
                }
                newNode.category=graph.categories.indexOf(type)
                graph.nodes.push(newNode)
            }
            graph.categories=graph.categories.map(x=>{return{name:x}})
            return({
                tooltip: {},
                legend: [
                    {
                        data: graph.categories.map(function (a) {
                            return a.name;
                        })
                    }
                ],
                series: [
                    {
                        type: 'graph',
                        layout: 'force',
                        data: graph.nodes,
                        links: graph.links,
                        categories: graph.categories,
                        roam: true,
                        force: {
                            repulsion: 100
                        },
                        label: {
                            show: true,
                            position: 'right',
                            formatter: '{b}'
                        },
                        labelLayout: {
                            hideOverlap: true
                        },
                        lineStyle: {
                            color: 'source',
                        }
                    }
                ]
            })
        },
    },
    mounted() {
        let newMappings={}
        for (let equip of Object.values(this.$store.state.pointsListStore.pointsList.equipment_details)){
            newMappings[equip.equipment_id]=equip.equipment_name
        }
        this.nameMap=newMappings
        this.initialize()
    },
    watch: {
        search() {
            this.debounce(this.syncSearches, 500);
        }
    },
    methods: {
        initialize() {
            this.refresh()
        },
        formatItem(item) {
            return {
                id: item.equipment_relationship_id,
                type: item.type,
                equip1:this.nameMap[item.equip1],
                equip2:this.nameMap[item.equip2],
            }
        },
        exportItems() {
            let cleanedItems = JSON.parse(JSON.stringify(this.equipmentRelationships))
            exportCSV(cleanedItems.map(item => this.formatItem(item)))
        },
        editItem(item) {
            this.editedItem = JSON.parse(JSON.stringify(item))
            this.dialog = true
        },
        async deleteItem(item) {
            if (confirm(this.$options.filters.translate('Are you sure you want to delete this item?'))) {
                await deleteEquipmentRelationship({
                    'equipment_relationship_id': item.equipment_relationship_id
                })
                this.refresh()
            }
        },
        handleECClick(data){
            if(data&&data.data){
                if(data.data.id){
                    let id=parseInt(data.data.id)
                    this.editedItem = JSON.parse(JSON.stringify({
                        equip1:id,
                        type:this.selectedType
                    }))
                    this.dialog = true
                } else if (data.data.source){
                    let equip1=parseInt(data.data.source)
                    let equip2=parseInt(data.data.target)
                    this.editedItem = JSON.parse(JSON.stringify(this.equipmentRelationships.filter(x=>x.equip1===equip1&&x.equip2===equip2)[0]))
                    this.dialog = true
                }
            }
        },
        async refresh() {
            let df = await getEquipmentRelationship({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name
            })
            this.equipmentRelationships = df['result']
            this.availableTypes=JSON.parse(JSON.stringify([...new Set(df['result'].map(x=>x.type))]))
            if (!this.selectedType&&this.availableTypes.length>0){
                this.selectedType=this.availableTypes[0]
            }
        },
        syncSearches() {
            this.search2 = this.search
        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
    }
}
</script>

<style scoped>

</style>
